import React, { Component, PropTypes } from "react";
import { Link } from "react-router";

class Footer extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { isOnLanding } = this.props;
    const links = isOnLanding
      ? [
          { label: "Terms of Service", to: "/terms_of_service" },
          { label: "Privacy Policy", to: "/privacy_policy" },
          { label: "About Us", to: "/about_us" },
          { label: "FAQs", to: "/faq" },
        ]
      : [
          // { label: "Cookie Policy", to: "/cookie_policy" },
          { label: "Terms of Service", to: "/terms_of_service" },
          { label: "Privacy Policy", to: "/privacy_policy" },
          { label: "About Us", to: "/about_us" },
          { label: "FAQs", to: "/faq" },
        ];
    return (
      <footer>
        <div className="max_width_nobg">
          <div className="logo">
            <Link to="/">
              {isOnLanding ? (
                <img src="/assets/img/logo.png" alt="logo" />
              ) : (
                <img src="/assets/img/Medcafe_logo.png" alt="logo" />
              )}
            </Link>
          </div>
          <div className="footer_container_info">
            <p className="copyright">© Medcafe 2023. All rights reserved.</p>
            <div className={`footer_links ${isOnLanding}`}>
              <ul>
                {links.map((link) => (
                  <li key={link.to}>
                    <Link to={link.to}>{link.label}</Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </footer>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/containers/Footer/Footer.js